import React from 'react'

const styleBase = {
  background: 'url(/img/wait-animation2.svg) 0 0 no-repeat',
  backgroundSize: 'contain'
}

const styleLarge = {
  ...styleBase,
  width: 40,
  height: 40
}

const styleSmall = {
  ...styleBase,
  width: 20,
  height: 20
}

export interface LoadingProps {
  size?: 'lg' | 'sm'
}

export const Loading = ({size = 'lg'}: LoadingProps) => (
  <div style={size === 'lg' ? styleLarge : styleSmall} />
)
